@if (initialized) {
    <div class="config-content-container surface-0">

        <!-- Provisionsmodelle: selectable CommissionModel (col-3) -> filtered CommissionRule (col-9) -->
        @if (activeNavItem === 'commissionModels') {
            <div class="grid">
                <!-- Master: selectable CommissionModel; selection filters the rule list (CONFIG-021) -->
                <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                    @if (widgets?.commissionModelWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.commissionModelWidget.widgetData"
                                (onObjectSelect)="onCommissionModelSelect($event)"
                                (onObjectDeselect)="onCommissionModelDeselect()">
                        </mvs-widget>
                    }
                </div>

                <!-- Detail: CommissionRule filtered by selected model; row-click opens the rule Object-Page (CONFIG-015) -->
                <div class="col-12 md:col-8 lg:col-9 h-full p-2 pt-0 scroll-table-container">
                    @if (commissionRuleWidgetData) {
                        <mvs-widget
                                [widgetData]="commissionRuleWidgetData"
                                (onObjectSelect)="navigateTo($event)">
                        </mvs-widget>
                    }
                </div>
            </div>
        }

        <!-- Zuordnungen: CommissionModelAssignment -->
        @if (activeNavItem === 'assignments') {
            <div class="grid">
                <div class="col-12 scroll-table-container">
                    @if (widgets?.commissionModelAssignmentWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.commissionModelAssignmentWidget.widgetData"
                                (onObjectSelect)="navigateTo($event)">
                        </mvs-widget>
                    }
                </div>
            </div>
        }

        <!-- Bemessungsgrundlagen: CommissionCalculationBase (flat catalog) -->
        @if (activeNavItem === 'calculationBases') {
            <div class="grid">
                <div class="col-12 scroll-table-container">
                    @if (widgets?.calculationBaseWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.calculationBaseWidget.widgetData"
                                (onObjectSelect)="navigateTo($event)">
                        </mvs-widget>
                    }
                </div>
            </div>
        }

        <!-- Caps: CommissionCap (flat catalog) -->
        @if (activeNavItem === 'caps') {
            <div class="grid">
                <div class="col-12 scroll-table-container">
                    @if (widgets?.capWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.capWidget.widgetData"
                                (onObjectSelect)="navigateTo($event)">
                        </mvs-widget>
                    }
                </div>
            </div>
        }

        <!-- Provisionspartner: CommissionPartner (flat catalog) -->
        @if (activeNavItem === 'commissionPartners') {
            <div class="grid">
                <div class="col-12 scroll-table-container">
                    @if (widgets?.commissionPartnerWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.commissionPartnerWidget.widgetData"
                                (onObjectSelect)="navigateTo($event)">
                        </mvs-widget>
                    }
                </div>
            </div>
        }

        <!-- Datenqualität: server-paginated DQ panel (FR-15) -->
        @if (activeNavItem === 'dataQuality') {
            <div class="grid">
                <div class="col-12 scroll-table-container">
                    <mvs-cn-data-quality-panel></mvs-cn-data-quality-panel>
                </div>
            </div>
        }

    </div>
}
